import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import GirlVerifyEmail from 'common/illustrations/GirlVerifyEmail';
import { Typography as T } from 'common/typography';

import { BREAKPOINT_MOBILE } from '../constants';

type Props = {
  success: boolean;
};

const Heading = styled(T.Heading1)`
  text-align: center;
`;

const Subheading = styled(T.Heading6)`
  text-align: center;
  font-weight: 400;
`;

const StyledIllustration = styled(GirlVerifyEmail)`
  max-width: 375px;
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 620px;
  height: 80%;
  margin: 0 auto;
  padding-inline: 16px;

  ${Heading} {
    margin-block-start: 32px;
    font-size: 48px;

    @media (max-width: ${BREAKPOINT_MOBILE}px) {
      font-size: 40px;
    }
  }

  ${Subheading} {
    margin-block-start: 16px;
    font-size: 20px;

    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      font-size: 20px;
    }
  }
`;

const CheckYourEmail = ({ success }: Props) => {
  const headingId = success
    ? 'merchant-sign-up.check-your-email.heading'
    : 'merchant-sign-up.check-your-email-expired-token.heading';

  const bodyId = success
    ? 'merchant-sign-up.check-your-email.body'
    : 'merchant-sign-up.check-your-email-expired-token.body';

  return (
    <Root>
      <StyledIllustration />
      <Heading>
        <FormattedMessage id={headingId} />
      </Heading>
      <Subheading>
        <FormattedMessage id={bodyId} />
      </Subheading>
    </Root>
  );
};

export default CheckYourEmail;
